import { render, staticRenderFns } from "./Destinatarios.vue?vue&type=template&id=4d6418b4&"
import script from "./Destinatarios.vue?vue&type=script&lang=js&"
export * from "./Destinatarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports